var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3970_13710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9895 5.36249C21.9895 5.09967 21.97 4.83686 21.9505 4.58378C21.8629 3.48386 21.7461 2.21847 21.0161 1.33269C20.3931 0.57345 19.4295 0.407976 18.5048 0.300904C17.3465 0.16463 16.1784 0.0867597 15.0103 0.0478244C12.645 -0.0397799 10.2797 0.00888915 7.91439 0.067292C6.69766 0.0964935 5.48093 0.125695 4.27394 0.213299C2.78467 0.330105 1.25646 0.553983 0.565356 2.03352C-0.0673421 3.36705 0.0105284 5.07047 0.000794597 6.50134C0.000794597 7.78621 -0.00893922 9.0808 0.0397299 10.3657C0.107867 12.0399 0.205205 14.2105 2.00596 14.9406C2.96961 15.3299 4.12793 15.4175 5.15972 15.4857C6.2499 15.5538 7.34009 15.5441 8.43028 15.5635C10.7177 15.5927 13.0052 15.5149 15.2926 15.4759C16.8792 15.4467 18.5145 15.4272 20.033 14.9114C21.347 14.4636 21.6877 13.0425 21.8629 11.8063C22.0381 10.5798 21.9992 9.33388 21.9895 8.10742C21.9895 7.19244 22.0089 6.2872 21.9895 5.37222V5.36249ZM8.77096 11.1054V4.40857C10.6691 5.52796 12.5477 6.62788 14.4652 7.757C12.5477 8.88613 10.6691 9.98605 8.77096 11.1054Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3970_13710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.a9bf053bd6a60645ab30d39c68c33a62.svg";
export { ForwardRef as ReactComponent };